import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function ToggleActivation({ userId, isDeactivated, onSuccess, onClose }: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const [reason, setReason] = useState('')

  const isDeactivating = !isDeactivated

  async function confirm() {
    setLoading(true)
    const endpoint = isDeactivating
      ? `admin/users/${userId}/deactivate`
      : `admin/users/${userId}/reactivate`
    const body = isDeactivating ? { reason: reason.trim() || undefined } : null
    put(endpoint, body)
      .then((result: any) => {
        if (result.success) {
          notify('success', result.message)
          onSuccess(result.data.deactivated)
          onClose()
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div
            className={`modal-icon ${isDeactivating ? 'icon-red' : 'icon-green'}`}
          >
            <Icon
              icon={
                isDeactivating
                  ? 'mdi:account-cancel-outline'
                  : 'mdi:account-check-outline'
              }
            />
          </div>
          <h2>{isDeactivating ? 'Deactivate' : 'Reactivate'} Account</h2>
          <p>
            {isDeactivating
              ? 'This user will be blocked immediately — they will not be able to log in, book shipments or perform any action until reactivated.'
              : 'This user will regain full access and be able to log in and use their account again.'}
          </p>
        </div>

        <div
          className={`status-indicator ${isDeactivated ? 'status-off' : 'status-on'}`}
        >
          <div className='dot' />
          <p>
            Current status: <span>{isDeactivated ? 'Deactivated' : 'Active'}</span>
          </p>
        </div>

        {isDeactivating && (
          <div className='form-group'>
            <label>Reason (optional)</label>
            <textarea
              rows={3}
              placeholder='e.g. fraudulent activity, unpaid debt...'
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        )}

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button
              className={isDeactivating ? 'btn-danger' : 'btn-proceed'}
              onClick={confirm}
            >
              {isDeactivating ? 'Deactivate' : 'Reactivate'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ToggleActivation
